import { render, staticRenderFns } from "./ChatBody.vue?vue&type=template&id=a30f168a&scoped=true&"
import script from "./ChatBody.vue?vue&type=script&lang=ts&"
export * from "./ChatBody.vue?vue&type=script&lang=ts&"
import style0 from "./ChatBody.vue?vue&type=style&index=0&id=a30f168a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30f168a",
  null
  
)

export default component.exports